import { setPageTitle } from '../../../../utils/utilities.js'
import ClearChatPolicy from './ClearChatPolicy.js'
import InitializeRoles from '../../InitializeSettings/initializeRoles.js'
import DeletePrivateMessages from './DeletePrivateMessages.js'
import Features from './Features.js'
import OneSignalAppId from './OneSignalAppId.js'

const General = () => {
  setPageTitle('Configuration | General')
  return (
    <div className="flex flex-col gap-2 mb-5">
      <Features />
      <ClearChatPolicy />
      <OneSignalAppId />
      <DeletePrivateMessages />
      <InitializeRoles />
    </div>
  )
}

export default General
